export type BackgroundJobStatus = "QUEUED" | "RUNNING" | "DONE" | "FAILED";
export type BackgroundJobTrigger = "MANUAL" | "SCHEDULE";

/** A background job: long work started from the UI or a schedule and run by a worker. */
export interface BackgroundJob {
  id: string;
  /** e.g. "importOrderStatuses". */
  kind: string;
  /** What it's about, e.g. a snapshot date "261023". */
  subject?: string;
  status: BackgroundJobStatus;
  /** The kind's own input. */
  input: unknown;
  /** The kind's own result, once DONE. */
  result: unknown;
  /** Set once FAILED. */
  error?: string;
  createdAt: string;
  startedAt?: string;
  finishedAt?: string;
  trigger: BackgroundJobTrigger;
  scheduleId?: string;
}

/** A link to download one of a job's files, good until expiresAt. */
export interface BackgroundJobFileDownload {
  name: string;
  url: string;
  expiresAt: string;
}

export interface BackgroundJobPage {
  backgroundJobs: BackgroundJob[];
  total: number;
}

/** How a form asks for a kind's input field: day (sent as yyMMdd), isoDate (yyyy-MM-dd), number (whole), select (one of `options`). */
export type BackgroundJobFieldType = "day" | "isoDate" | "number" | "select";

export interface BackgroundJobField {
  name: string;
  label: string;
  type: BackgroundJobFieldType;
  required: boolean;
  options: { value: string; label: string }[];
  help?: string;
}

/** A kind of job — its label, whether a schedule can run it, and its input. */
export interface BackgroundJobKind {
  kind: string;
  label: string;
  schedulable: boolean;
  fields: BackgroundJobField[];
}

/** Still going — worth polling. */
export const isBackgroundJobActive = (job: BackgroundJob | undefined): boolean => {
  return job?.status === "QUEUED" || job?.status === "RUNNING";
};
